import React from 'react'
import { Box, Text, Flex } from 'pcln-design-system'

type InventoryViewType = {
  xSellMessaging: string
  children: React.ReactNode
}

const Heading = ({ xSellMessaging }: { xSellMessaging: string }) => (
  <Text color="text.heading" textStyle={['heading4', null, null, 'heading5']}>
    {xSellMessaging}
  </Text>
)

const HeadingNonXL = ({ xSellMessaging, children }: InventoryViewType) => (
  <Flex
    flexDirection="column"
    justifyContent="space-between"
    alignItems="baseline"
    ml={[3, null, null, 0]}
  >
    <Heading xSellMessaging={xSellMessaging} />
    <Box mt={3}>{children}</Box>
  </Flex>
)

const HeadingXL = ({ xSellMessaging, children }: InventoryViewType) => (
  <Flex justifyContent="space-between" alignItems="baseline">
    <Heading xSellMessaging={xSellMessaging} />
    {children}
  </Flex>
)

export { HeadingNonXL, HeadingXL }
